/* Sowth cart drawer — global open/close, AJAX add/change via Section Rendering API,
   delegated controls. Centralizes quick-add for every .s-add[data-variant-id] on the store.
   No-JS fallback stays intact (links/forms work without this script). */
(function () {
  'use strict';
  var SECTION = 'sowth-cart-drawer';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var panel = drawer.querySelector('[data-drawer-panel]');
  var lastFocus = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bubble() {
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      if (s && s['cart-icon-bubble']) { var d = document.getElementById('cart-icon-bubble'); if (d) d.innerHTML = s['cart-icon-bubble']; }
    }).catch(function () {});
  }

  /* Publish Dawn's standard cart-update so Shopify analytics (shop_events_listener.js),
     the Meta/TikTok web pixels, and any cartUpdate subscriber fire on AJAX adds.
     Without this, custom adds never emit AddToCart and the listener throws. */
  function publishCartUpdate(source, id, data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: source, productVariantId: String(id), cartData: data });
      }
    } catch (e) {}
  }

  function setBody(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-drawer-body]');
    var live = drawer.querySelector('[data-drawer-body]');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sdrawer-open');
    // focus the panel for screen readers / keyboard
    window.setTimeout(function () { if (panel) panel.focus(); }, reduce ? 0 : 120);
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sdrawer-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function isOpen() { return drawer.getAttribute('aria-hidden') === 'false'; }

  /* Refresh the drawer body from the server (used after an external add) then open. */
  function refreshAndOpen() {
    fetch('/?sections=' + SECTION).then(function (r) { return r.json(); }).then(function (s) {
      if (s && s[SECTION]) setBody(s[SECTION]);
      bubble(); open();
    }).catch(function () { open(); });
  }

  function addVariant(id, qty, btn) {
    if (!id) return;
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }], sections: [SECTION], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status) { // error (e.g. sold out)
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); }
        return;
      }
      if (data.sections && data.sections[SECTION]) setBody(data.sections[SECTION]);
      publishCartUpdate('sowth-drawer', id, data);
      bubble(); open();
      if (btn) {
        btn.classList.remove('loading'); btn.removeAttribute('aria-busy');
        var orig = btn.innerHTML; btn.classList.add('added'); btn.innerHTML = '✓';
        window.setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = orig; }, 1300);
      }
    }).catch(function () {
      if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); }
      window.location.href = '/cart';
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: [SECTION], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.sections && data.sections[SECTION]) setBody(data.sections[SECTION]);
      bubble();
    }).catch(function () {});
  }

  /* expose for PDP / other scripts */
  window.SowthDrawer = { open: open, close: close, refresh: refreshAndOpen, add: addVariant };

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    // open from header cart icon (any link to the cart route, opt-out with data-no-drawer)
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-toggle]');
    if (cartLink && !cartLink.hasAttribute('data-no-drawer') && !cartLink.closest('[data-cart-drawer]')) {
      e.preventDefault(); refreshAndOpen(); return;
    }
    // close
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); return; }
    // quick-add buttons store-wide (single-variant cards)
    var add = e.target.closest('.s-add[data-variant-id]');
    if (add && add.tagName === 'BUTTON') {
      e.preventDefault(); e.stopPropagation();
      if (add.classList.contains('loading') || add.classList.contains('added')) return;
      addVariant(add.getAttribute('data-variant-id'), 1, add);
      return;
    }
    // qty +/- and remove inside the drawer
    var qa = e.target.closest('[data-cart-drawer] [data-qty-change]');
    if (qa) {
      e.preventDefault();
      var u = new URL(qa.href, window.location.origin);
      var key = u.searchParams.get('id'); var q = u.searchParams.get('quantity');
      if (key != null && q != null) changeLine(key, parseInt(q, 10));
      return;
    }
  }, true);

  /* external adds (legacy handlers) can ask the drawer to refresh + open */
  document.addEventListener('sowth:cart:added', function () { refreshAndOpen(); });

  /* keyboard: ESC closes, basic focus trap */
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab' && panel) {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
